import React from 'react';
import { FileText, CloudUpload, ShieldCheck, Lock } from 'lucide-react';

const styles = {
  hero: {
    padding: '72px 0 48px',
    textAlign: 'center',
    animation: 'fadeUp 0.5s ease both',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  eyebrow: {
    fontSize: '11px',
    letterSpacing: '0.18em',
    textTransform: 'uppercase',
    color: 'var(--accent)',
    marginBottom: '18px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
  },
  eyebrowLine: {
    width: '28px',
    height: '1px',
    background: 'var(--accent)',
    opacity: 0.5,
  },
  h1: {
    fontFamily: 'var(--font-display)',
    fontSize: 'clamp(48px, 7vw, 72px)',
    fontWeight: 600,
    lineHeight: 1.02,
    letterSpacing: '-0.04em',
    color: 'var(--text)',
    marginBottom: '24px',
    maxWidth: '760px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  h1Italic: {
    fontStyle: 'italic',
    color: 'var(--accent)',
  },
  sub: {
    fontSize: '15px',
    color: 'var(--text-muted)',
    letterSpacing: '0.02em',
    maxWidth: '640px',
    margin: '0 auto 36px',
    lineHeight: 1.8,
  },
};

export default function Hero() {
  return (
    <section style={styles.hero}>
      <div style={styles.eyebrow}>
        <span style={styles.eyebrowLine} />
        Free File Converter
        <span style={styles.eyebrowLine} />
      </div>
      <h1 style={styles.h1}>
        Convert <em style={styles.h1Italic}>anything</em>
        <br />to anything
      </h1>
      <p style={styles.sub}>
        25+ conversion formats. No sign-up, no limits.
        Your files stay on your device.
      </p>
      
      <div className="stats-container">
        <div className="stat-item">
          <div className="stat-icon-wrapper color-purple">
            <FileText size={22} strokeWidth={2.5} />
          </div>
          <div className="stat-text-col">
            <div className="stat-num">25+</div>
            <div className="stat-label">Formats</div>
          </div>
        </div>
        
        <div className="stat-divider" />
        
        <div className="stat-item">
          <div className="stat-icon-wrapper color-blue">
            <CloudUpload size={22} strokeWidth={2.5} />
          </div>
          <div className="stat-text-col">
            <div className="stat-num">50MB</div>
            <div className="stat-label">Max File Size</div>
          </div>
        </div>
        
        <div className="stat-divider" />
        
        <div className="stat-item">
          <div className="stat-icon-wrapper color-green">
            <ShieldCheck size={22} strokeWidth={2.5} />
          </div>
          <div className="stat-text-col">
            <div className="stat-num">100%</div>
            <div className="stat-label">Private</div>
          </div>
        </div>
        
        <div className="stat-divider" />
        
        <div className="stat-item">
          <div className="stat-icon-wrapper color-orange">
            <Lock size={22} strokeWidth={2.5} />
          </div>
          <div className="stat-text-col">
            <div className="stat-num">Free</div>
            <div className="stat-label">Always</div>
          </div>
        </div>
      </div>
    </section>
  );
}
